import {pages} from "../../../../shared/constants/pages";
import routesNames from "../../../../shared/constants/router";
import svgIcons from "../../../../shared/constants/icons/svg-icons";

const policiesSettings = [
  {
    text: pages.policies.privacy_policy,
    icon: svgIcons.privacy,
    routeName: routesNames.administration.editPrivacyPolicy
  },
  {
    text: pages.policies.terms_and_conditions,
    icon: svgIcons.terms,
    routeName: routesNames.administration.editTermsAndConditions
  }
];

export default policiesSettings;
